import(/* webpackMode: "eager", webpackExports: ["VaultClient"] */ "/codebuild/output/src35030413/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/vaults/[id]/VaultClient.tsx");
